module.exports = __webpack_public_path__ + "img/burst_pressure.60512050.svg";